import { UserLoginHttp } from '@rhybus/api'
import { apiPath, fetchProvider } from './api'
import {CLIENT_CODE_LABEL} from '../../constants/globalConstants'
import {encryptHeader} from '../../utils/globalFunctions'

declare const process: {
  env: {
    REACT_APP_CLIENT_CODE?: string
  }
}

export const anewUserLoginHttp = () => {
  try {
    localStorage.setItem(CLIENT_CODE_LABEL,'')
    const encryptedKey = encryptHeader(process.env.REACT_APP_CLIENT_CODE!);
    localStorage.setItem(CLIENT_CODE_LABEL,encryptedKey);
    return new UserLoginHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint UserLoginHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)
    throw error 
  }
}

